import request from "@/utils/request";
import requestCache from "@/utils/requestWithCache";

export function getRatios(params) {
  return requestCache({
    url: `/api/admin/banners/ratios/`,
    method: "get",
    params,
  });
}
export function getRatioById(ratioId) {
  return request({
    url: `/api/admin/banners/ratios/${ratioId}/`,
    method: "get",
  });
}
export function createRatio(data) {
  return request({
    url: `/api/admin/banners/ratios/`,
    method: "post",
    data,
  });
}
export function deleteRatio(ratioId) {
  return request({
    url: `/api/admin/banners/ratios/${ratioId}/`,
    method: "delete",
  });
}
export function updateRatio(ratioId, data) {
  return request({
    url: `/api/admin/banners/ratios/${ratioId}/`,
    method: "patch",
    data,
  });
}
